import { join, map, pipe, prop } from 'ramda';

import {
  getArtialArrhythmia,
  getArtialArrhythmiaType,
  getPriorVentricularArrhythmiaRecent,
  getPriorVentricularArrhythmiaRecentDate,
  getIcdIndCode,
  getIcdIndSecDisplay,
  getIsPriorCurrentTreatment,
} from 'store/selectors/questionnaireResponses';
import i18n from 'services/i18n';

export function getpriorTreatmentDetection(state, patientId) {
  const icdIndCode = getIcdIndCode(patientId)(state);

  return `${
    icdIndCode === '2'
      ? `${i18n.t('yes')}: ${getIcdIndSecDisplay(patientId)(state)}`
      : `${i18n.t('no')}`
  }`;
}

export function getPriorVentricularArrhythmia(state, patientId) {
  const recentDate = getPriorVentricularArrhythmiaRecentDate(patientId)(state);
  const isVA = getPriorVentricularArrhythmiaRecent(patientId)(state);

  return isVA === 'Yes' ? `${isVA}: ${recentDate}` : isVA;
}

export function getPriorCurrentTreatment(state, patientId) {
  const itemArray = state.questionnaireResponses[patientId].data.item;
  // const isAvailable = itemArray.find(item => item.linkId === 'b_dev_treat_type');
  const isAvailable = itemArray.find(item => item.linkId === 'b_va_treat');

  const treatment = !!isAvailable && `${getIsPriorCurrentTreatment(patientId)(state)}`;

  return treatment;
}

export function getFormattedPriorArtialArrhythmia(state, patientId) {
  const artialArrhythmia = getArtialArrhythmia(patientId)(state);
  if (artialArrhythmia === '1') {
    const type = getArtialArrhythmiaType(patientId)(state);
    return `${i18n.t('yes')}: ${type}`;
  }
  return i18n.t('no');
}

export function getFormattedCardiacRiskFactors(factors) {
  return pipe(
    map(prop('text')),
    join(', '),
  )(factors);
}

export function getFormattedEjectionFraction({ value, date, method }) {
  return `${value}%, ${date}, ${i18n.t('reports.method')}: ${method}`;
}
